module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/005_Foreword#fm-1"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Foreword")]), _vm._v(" by Mark Labberton")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Acknowledgments#fm-2"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm1"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Introduction#fm-3"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter01#ch-1"
    }
  }, [_vm._v("1. "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Wisdom from Above")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Wisdom and the World around Us")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Wisdom and Humility")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Wisdom and Different Kinds of Power")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Wisdom and Healthy Practices of Power")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Wisdom and Leadership Formation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Wisdom and Leadership Imagination")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter08#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. "), _c('span', {
    staticClass: "pad"
  }, [_vm._v("Wisdom in Three Dimensions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Epilogue#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm1"
  }, [_c('span', {
    attrs: {
      "href": "#/017_WorksCited#bm-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Works Cited")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f02093a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004_Contents.vue
// module id = 66
// module chunks = 0